export const ACTION_TYPES = {
  EDIT: 'Edit',
  DOWNLOAD: 'Download',
};
